import useCrmApi from "../../../components/hook/crm-req";

// useCrmApi's baseURL already ends in /api/v1, so these endpoints omit that
// prefix (matches every other useCrmApi call in this codebase, e.g. "/leads").
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("authToken")}` });

// GET /lead-qr-campaigns — no pagination, newest first. There's no
// single-campaign GET, so this is also how an existing campaign is loaded
// for editing (per qr-lead-ui-integration.md).
export const useListLeadQrCampaigns = () => useCrmApi("/lead-qr-campaigns", "GET", authHeaders());

// POST /lead-qr-campaigns — body: LeadQrCampaignInput.
export const useCreateLeadQrCampaign = () => useCrmApi("/lead-qr-campaigns", "POST", authHeaders());

// PATCH /lead-qr-campaigns/{id} — body: Partial<LeadQrCampaignInput> & { status? }.
export const useUpdateLeadQrCampaign = () => useCrmApi("/lead-qr-campaigns", "PATCH", authHeaders());
